import axios from 'axios'

const HOST_URL = process.env.VUE_APP_API_HOST

export default {
    getActTemplates (payload = {}) {
        return axios.get(`${HOST_URL}/act-templates`, {
            params: payload
        })
    },
    getActTemplate (id) {
        return axios.get(`${HOST_URL}/act-template/${id}`)
    },
    createActTemplate(payload = {}) {
        return axios.post(`${HOST_URL}/act-template`, payload)
    },
    deleteActTemplate(id = null) {
        return axios.delete(`${HOST_URL}/act-template/${id}`)
    }
}
